export const sliceTimestamp = timestamp => {
  const timeStampLength = 10;

  if (timestamp.toString().length > timeStampLength) {
    timestamp = Math.round(timestamp / 1000);
  }

  return timestamp;
};
